import { ComparableObject, ComparableValue } from 'crossfilter2';
import { Moment } from 'moment-timezone';

export interface IGroupedDimension extends ComparableObject {
  timestamp?: Moment;
  dimension?: ComparableValue;
  label: string;
}
